/* tslint:disable:component-selector component-class-suffix no-trailing-whitespace one-line */

import {
  Component,
  Input,
  Renderer2,
  ElementRef
} from '@angular/core';

@Component({
  selector: 'tab',
  styles: [
    `
    .pane{
      padding: 1em;
    }
  `
  ],
  template: `
    <div [hidden]="!active" class="nav-tab-pane">
      <ng-content></ng-content>
    </div>
  `
})

/**
 *
 * @class Tab
 *
 * @brief single panel in a tabbed container
 *
 * @link https://juristr.com/blog/2016/02/learning-ng2-creating-tab-component/
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      October 2019
 *
 */
export class Tab {
  @Input() title  = 'No Title';
  @Input() active = false;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef)
  {

  }

  public activate() {
    this.renderer.addClass(this.el.nativeElement, 'active');
  }

  public deactivate() {
    this.renderer.removeClass(this.el.nativeElement, 'active');
  }
}
